import React from 'react';
import Button from '../../../../components/Button';
import Image from '../../../../components/Image';
import MaxWidthContainer from '../../../../components/MaxWidthContainer';
import PageSectionTitle from '../../../../components/PageSectionTitle';
import Text from '../../../../components/Text';

import './IntroBanner.scss';

const IntroBanner = ({
  title,
  description,
  btnText,
  heroImageData,
  onCTAClick,
}) => {
  const className = 'c-HomePageContainer-IntroBanner';

  return (
    <div className={className}>
      <MaxWidthContainer>
        <div className={`${className}__gradient desktop-only`}></div>
        <div className={`${className}__wrapper`}>
          <div className={`${className}__media`}>
            <Image {...heroImageData} />
          </div>
          <div className={`${className}__info`}>
            <PageSectionTitle title={title} />
            <Text text={description} />
            <Button displayType="primary" newVersion onClick={onCTAClick}>
              {btnText}
            </Button>
          </div>
        </div>
      </MaxWidthContainer>
    </div>
  );
};

export default IntroBanner;
